import axios from "axios";

const apiAnimals = axios.create({
  baseURL: process.env.REACT_APP_BOVEXO_ANIMALS_URL,
  validateStatus: (status) => status >= 200 && status < 300,
  // baseURL: "http://localhost:8084",
});

export default apiAnimals;
